import AlphaFilters from '@nematis/wp-alpha/assets/js/abstracts/classes/alpha-filters'
import {
  collapseFaqItems
} from './faq-collapse'

// The Gutenberg `rank-math/faq-block` ships plain markup: Alpha's `blocks/rank-math-faq.js` is what
// upgrades it into a Bootstrap accordion, and it loads as a dynamic chunk — so there is nothing to
// hook on at DOM ready. `load.blocks` is the extension point that lets us await that import before
// taking over.
// We then flag the resulting accordion as a `faq-block`, which is all it takes for the whole HP FAQ
// styling to apply verbatim (assets/sass/blocks/faq.scss) — no selector is duplicated. Alpha's own
// FaqBlock also carries `accordion-flush`, hence the second class.
AlphaFilters.addFilter('load.blocks', (importer, blockName) => {
  if (blockName !== 'rank-math-faq') {
    return importer
  }

  return async () => {
    await importer()

    document.querySelectorAll('.rank-math-faq .rank-math-list').forEach((accordion) => {
      accordion.classList.add('faq-block', 'accordion-flush')
      collapseFaqItems(accordion)
    })
  }
}, 'child/rank-math-faq')
